import seamlessBg from "img/bg_seamless_trading.png";

export function SeamlessBackground() {
  return (
    <img
      src={seamlessBg}
      alt="Seamless Trading"
      className="absolute bottom-0 right-8 h-[180px] w-[340px] max-sm:opacity-30"
    />
  );
}
